import { fetchFlask } from '../../utils/fetchFlask';

export const fetchInadimplenciaMes = async ({ dataInicio, dataFim }) => {
    const response = await fetchFlask('getInadimplenciaMes', JSON.stringify({
        data_inicio: dataInicio,
        data_fim: dataFim
    }));
    return response.inadimplencia;
};

export const fetchListaInadimplentes = async ({ dataInicio, dataFim }) => {
    const response = await fetchFlask('listarInadimplentes', JSON.stringify({
        data_inicio: dataInicio,
        data_fim: dataFim
    }));
    return response.inadimplentes;
};

export const buildTelefoneContato = (ddd, telefone) => {
    if (!telefone) return '';

    return ddd ? `(${ddd}) ${telefone}` : String(telefone);
};

export const buildInadimplentesRows = (inadimplentes) => inadimplentes.map((inadimplente, index) => ({
    id: index,
    clienteId: inadimplente.cliente_id,
    razaoSocial: inadimplente.cliente,
    contatoNome: inadimplente.contato_nome ?? '',
    contatoTelefone: buildTelefoneContato(inadimplente.contato_ddd, inadimplente.contato_telefone),
    dividaTotal: inadimplente.divida_total,
    quantidade: inadimplente.quantidade
}));

export const buildInadimplenciaKpis = (inadimplencia) => ({
    percentualAtrasadoValor: inadimplencia.total_atrasado / inadimplencia.total_faturado,
    percentualAtrasadoQuantidade: inadimplencia.quantidade_atrasado / inadimplencia.quantidade_faturado,
    percentualAcordoValor: inadimplencia.total_acordo / inadimplencia.total_atrasado,
    percentualAcordoQuantidade: inadimplencia.quantidade_acordo / inadimplencia.quantidade_atrasado,
    totalAtrasadoSemAcordo: inadimplencia.total_atrasado - inadimplencia.total_acordo,
    quantidadeAtrasadoSemAcordo: inadimplencia.quantidade_atrasado - inadimplencia.quantidade_acordo,
    totalEmDia: inadimplencia.total_faturado - inadimplencia.total_atrasado - inadimplencia.total_ate_30_dias - inadimplencia.total_apos_30_dias,
    quantidadeEmDia: inadimplencia.quantidade_faturado - inadimplencia.quantidade_atrasado - inadimplencia.quantidade_ate_30_dias - inadimplencia.quantidade_apos_30_dias
});

export const buildFaturamentoComposition = (inadimplencia, kpis) => [
    {
        key: 'atrasados',
        label: 'Atrasados',
        value: inadimplencia.total_atrasado,
        count: inadimplencia.quantidade_atrasado,
        color: 'var(--erro)'
    },
    {
        key: 'ate30',
        label: 'Até 30 Dias',
        value: inadimplencia.total_ate_30_dias,
        count: inadimplencia.quantidade_ate_30_dias,
        color: '#2f8fcf'
    },
    {
        key: 'apos30',
        label: 'Após 30 Dias',
        value: inadimplencia.total_apos_30_dias,
        count: inadimplencia.quantidade_apos_30_dias,
        color: '#39c9c9'
    },
    {
        key: 'emDia',
        label: 'Em dia',
        value: kpis.totalEmDia,
        count: kpis.quantidadeEmDia,
        color: '#004f86'
    }
];
